import { Container, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        width: '100%',
        height: '100vh',
        padding: '0 100px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 30px',
        },
    },
}));

const Layout = (props) => {
    const [isMobileNavOpen, setMobileNavOpen] = useState(true);

    const classes = useStyles();

    return (
        <Router>
            <ScrollToTop />
            <div className={classes.root}>
                <Topbar onMobileNavOpen={() => setMobileNavOpen(true)} />
                <Sidebar
                    onMobileClose={() => setMobileNavOpen(false)}
                    openMobile={isMobileNavOpen}
                />
                <Container id='content' className={classes.content}>
                    {props.children}
                </Container>
            </div>
        </Router>
    );
};

export default Layout;
